import React from 'react';
import { useTranslation } from 'react-i18next';

const OrderActionButtons = ({
    onBack,
    onSend,
    onDownloadPdf,
    onBackToPatients,
    sendingEmail,
    disableSend,
    showBack = true,
    className = 'flex justify-between pt-4 border-t'
}) => {
    const { t } = useTranslation();

    return (
        <div className={className}>
            {showBack ? (
                <button
                    type="button"
                    onClick={onBack}
                    className="btn-secondary"
                >
                    {t('common.back')}
                </button>
            ) : (
                <div />
            )}
            <div className="flex gap-3">
                <button
                    type="button"
                    onClick={onSend}
                    disabled={disableSend || sendingEmail}
                    className="btn-secondary flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l9 6 9-6m-18 0l9-6 9 6m-18 0v8a2 2 0 002 2h14a2 2 0 002-2V8" />
                    </svg>
                    {sendingEmail ? t('common.sending') : (t('common.send') || 'Send')}
                </button>
                <button
                    type="button"
                    onClick={onDownloadPdf}
                    className="btn-secondary flex items-center gap-2"
                >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
                    </svg>
                    {t('measurements.stockingSelection.order.downloadPDF')}
                </button>
                <button
                    type="button"
                    onClick={onBackToPatients}
                    className="btn-primary"
                >
                    {t('patients.buttons.backToPatients')}
                </button>
            </div>
        </div>
    );
};

export default OrderActionButtons;
